export default __webpack_public_path__ + "static/media/ic-call-us.bc706b17.svg";